import Vue from 'vue'

import { getCurrentInstance, mountVueToBody } from '@/util'

export default function usePrompt() {
  const instance = getCurrentInstance()

  async function prompt(options: {
    title: string
    label: string
    initial?: string
  }): Promise<string | undefined> {
    const { default: opts } = await import('./components/AppPrompt.vue')
    return new Promise((resolve) => {
      const c = new Vue({
        extends: opts,
        parent: instance.proxy.$root,
        propsData: options,
      })
      const destroy = mountVueToBody(c)
      c.$once('success', (value: string) => {
        resolve(value)
        destroy()
      })
      c.$once('fail', () => {
        resolve(undefined)
        destroy()
      })
    })
  }

  return {
    prompt,
  }
}
